module.exports = __webpack_public_path__ + "static/media/b2.f346d508.gif";